<template>
  <div class="main-body--content">
    <div class="parlor-left">
      <c-block-box
        title="活跃率"
        class="margin-bottom-1rem"
      >
        <div class="num-pie--box">
          <div class="left">
            <div class="value">{{ percentage(parlorData.weekOpen.activeRate || 0) }}%</div>
            <div class="tendency">
              <!-- <div class="tendency-text">
                <span>周环比</span>
                <img :src="upsAndDowns(parlorData.weekOpen.weekCountCompare)" />
                <em>{{ (parlorData.weekOpen.weekCountCompare * 100).toFixed(2) }}%</em>
              </div> -->
              <div class="tendency-text">
                <span>同比</span>
                <img :src="upsAndDowns(parlorData.weekOpen.activeRateCompare || '0')" />
                <em>{{ percentage(parlorData.weekOpen.activeRateCompare || '0') }}%</em>
              </div>
            </div>
            <div class="target-rate">
              <c-target-rate
                label="目标"
                :target="`${percentage(parlorData.weekOpen.activeRateTarget || '0')}%`"
                :is-progress="false"
              >
              </c-target-rate>
              <c-target-rate
                label="完成率"
                :num="percentage(parlorData.weekOpen.activeRateTargetRate || '0')"
              >
              </c-target-rate>
            </div>
          </div>
          <div class="right">
            <ChartBarLine
              id="iuiehege"
              height="8.1rem"
              v-if="weekOpenChart.data"
              :option="weekOpenChart"
            ></ChartBarLine>
          </div>
        </div>
      </c-block-box>
      <c-block-box
        title="业务拓展关键指标"
      >
        <!--<div-->
        <!--slot="sub-title"-->
        <!--id="details-btn"-->
        <!--class="digital-btn coocaa_btn"-->
        <!--leftTarget="#details-btn"-->
        <!--upTarget="#Parlor"-->
        <!--depLink="#/kanban-config-view?id=2"-->
        <!--rel="digitalDetails"-->
        <!--@click="seeDetails('kanbanConfigView', {-->
        <!--id: '2'-->
        <!--})"-->
        <!--&gt;详情</div>-->
        <div
          v-for="(item, index) of livingRoom"
          :key="item.value"
          slot="sub-title"
          :id="`details-btn${index}`"
          class="digital-btn coocaa_btn digital-btn-mut"
          leftTarget="#details-btn"
          upTarget="#Parlor"
          :router="`/kanban-config-view?id=${item.value}`"
          rel="digitalDetails"
          @click="seeDetails(`/kanban-config-view?id=${item.value}`)"
        >
          {{ item.label }}
        </div>
        <div style="height: 33rem">
          <div class="table-item">
            <div class="table-head">
              <div class="head-item" style="width:200px">指标</div>
              <div class="head-item">本月目标</div>
              <div class="head-item">当前值</div>
              <div class="head-item" style="padding: 0 1rem;width: 6rem">完成率</div>
            </div>
            <div class="table-body">
              <div class="table-line" v-for="(tableItem, index) in tableData" :key="index">
                <div class="body-lable" style="width:200px">{{ tableItem.name }}</div>
                <div class="body-lable">
                  {{
                    tableItem.name!=='活跃用户量(台)' &&
                      tableItem.name!=='日均起播时长(小时)' &&
                      tableItem.name!=='ARPU值' ?
                        `${percentage(tableItem.target)}%` :
                        (tableItem.target).toFixed(tableItem.name ==='活跃用户量(台)' ? 0 : 2) }}
                </div>
                <div class="body-lable">
                  {{
                    tableItem.name!=='活跃用户量(台)' &&
                      tableItem.name!=='日均起播时长(小时)' &&
                      tableItem.name!=='ARPU值' ?
                        percentage(tableItem.current)+'%' :
                        (tableItem.current).toFixed(tableItem.name ==='活跃用户量(台)' ? 0 : 2)
                  }}
                </div>
                <div class="body-lable" style="padding: 0 1rem;width: 6rem">
                  <c-progress
                    class="c-progress"
                    height="1rem"
                    style="margin-top: .55rem"
                    :num="tableItem.finishRatio || 0"
                  ></c-progress>
                </div>
              </div>
            </div>
          </div>
          <div style="color:#fff;font-size:1rem;padding:0 1.5rem; margin-top:1rem">月分业务线指标</div>
          <div class="table-item">
            <div class="table-head head-item__month">
              <div class="head-item">业务线</div>
              <div class="head-item">活跃率  环比</div>
              <div class="head-item">转化率  环比</div>
            </div>
            <div class="table-body">
              <div class="table-line" v-for="(tableItem, index) in parlorData.businessIndicators" :key="index">
                <div class="body-lable">{{ tableItem.business }}</div>
                <div class="body-lable">
                  <img :src="upsAndDowns(tableItem.activeRateCompare)" />
                  {{ percentage(tableItem.activeRate) }}%
                  {{ tableItem.activeRateCompare >= 0 ? '+' : '' }}
                  {{ percentage(tableItem.activeRateCompare) }}%
                </div>
                <div class="body-lable">
                  <img :src="upsAndDowns(tableItem.conversionRateCompare)" />
                  {{ percentage(tableItem.conversionRate) }}%
                  {{ tableItem.conversionRateCompare >= 0 ? '+' : '' }}
                  {{ percentage(tableItem.conversionRateCompare) }}%
                </div>
              </div>
            </div>
          </div>
        </div>
      </c-block-box>
    </div>
    <div class="main-body--right">
      <div class="tendency-flex margin-bottom-1rem">
        <div class="tendency-flex--left">
          <c-block-box
            title="转化率"
          >
            <div class="num-pie--box">
              <div class="left">
                <div class="value">{{ percentage(parlorData.weekOpen.conversionRate || 0) }}%</div>
                <div class="tendency">
                  <div class="tendency-text">
                    <span>同比</span>
                    <img :src="upsAndDowns(parlorData.weekOpen.conversionRateCompare || '0')" />
                    <em>{{ percentage(parlorData.weekOpen.conversionRateCompare || '0') }}%</em>
                  </div>
                </div>
                <div class="target-rate">
                  <c-target-rate
                    label="目标"
                    :target="`${percentage(parlorData.weekOpen.conversionRateTarget || '0')}%`"
                    :is-progress="false"
                  ></c-target-rate>
                  <c-target-rate
                    label="完成率"
                    :num="percentage(parlorData.weekOpen.conversionRateTargetRate || '0')"
                  >
                  </c-target-rate>
                </div>
              </div>
              <div class="right">
                <ChartBarLine
                  id="iuiehege1"
                  height="7.7rem"
                  v-if="weekConversionChart.data"
                  :option="weekConversionChart"
                ></ChartBarLine>
              </div>
            </div>
          </c-block-box>
        </div>
        <div class="tendency-flex--right">
          <c-block-box
            title="月总营收（万元）"
          >
            <div class="num-pie--box">
              <div class="left">
                <div class="value">{{ numberSplitWithComma(parlorData.weekOpen.monthNetIncome || 0) }}</div>
                <div class="tendency">
                  <div class="tendency-text">
                    <span>环比</span>
                    <img :src="upsAndDowns(parlorData.weekOpen.monthNetRatio || '0')" />
                    <em>{{ percentage(parlorData.weekOpen.monthNetRatio || '0') }}%</em>
                  </div>
                </div>
                <div class="target-rate inline-rate">
                  <c-target-rate
                    label="目标"
                    :target="`${ (parlorData.weekOpen.monthTarget * 1 || 0) }万`"
                    :is-progress="false"
                  ></c-target-rate>
                  <c-target-rate
                    label="完成率"
                    :num="percentage(parlorData.weekOpen.monthFinishRatio || '0')"
                  >
                  </c-target-rate>
                </div>
                <div class="net-method">
                  <label for="">全额营收</label>&nbsp;
                  <em>{{ numberSplitWithComma(parlorData.weekOpen.monthIncome || 0) }} 万</em>
                </div>
              </div>
              <div class="right">
                <ChartBarLine
                  id="iuiehege2"
                  height="7.7rem"
                  v-if="dayIncome.data"
                  :option="dayIncome"
                ></ChartBarLine>
              </div>
            </div>
          </c-block-box>
        </div>
      </div>
      <c-block-box title="近3月项目支撑情况">
        <div class="business-tags" slot="sub-title">
          <span>启动阶段</span>
          <span class="span1">实施阶段</span>
          <span class="span2">收尾阶段</span>
        </div>
        <project-list :start-time="1609459200000" :end-time="1617148800000" :project="projectLIst"></project-list>
      </c-block-box>
    </div>
  </div>
</template>

<script>
import ChartBarLine from '@/components/echarts/line2'
import common from '@/mixins/common.js'
import ProjectList from './components/ProjectList'
export default {
  mixins: [common],
  components: {
    ChartBarLine,
    ProjectList
  },
  props: {},
  data () {
    return {
      month: '',
      weekOpenChart: {},
      weekConversionChart: {},
      dayIncome: {},
      tableData: [],
      barLine: [],
      // timeData: {},
      projectItem: {
        1: 'verification',
        2: 'dev',
        3: 'success',
        4: 'fail'
      },
      projectLIst: [],
      parlorData: {
        weekOpen: {},
        businessIndicators: [],
        nps: {},
        projects: []
      },
      livingRoom: [
        { label: '分类明细', value: 2 },
        { label: '机型', value: 7 },
        { label: '设备源', value: 10 },
        { label: '业务类型', value: 12 },
        { label: '用户类型', value: 13 }
      ]
    }
  },
  computed: {},
  methods: {
    lineFormatData (data, key, yKey, type) {
      const isAndroid = this.$store.state.app.isAndroid
      const keys = Object.keys(data)
      let minValueArr = []
      keys.forEach((item) => {
        minValueArr.push(this.mathMin(data[item].data))
      })
      const minValue = this.mathMin(minValueArr)
      const option = {
        config: {
          xData: data[keys[0]].date.map(item => {
            return this.$cUtils.format.formatDate(item, 'MM-dd')
          }),
          splitNumber: 2,
          legend: {
            top: !isAndroid ? 20 : 10,
            right: 10
          },
          grid: {
            top: 45,
            right: 10,
            bottom: 10
          },
          yAxis: []
        },
        data: []
      }
      const yAxis = {
        name: yKey[0],
        type: 'value',
        splitLine: {
          lineStyle: {
            color: 'rgba(255,255,255,0.1)'
          }
        },
        min: minValue,
        axisLine: {
          show: false
        },
        axisLabel: {
          show: true,
          textStyle: {
            color: 'rgba(255,255,255,.6)',
            fontSize: !isAndroid ? 12 : 10
          }
        },
        nameTextStyle: {
          color: '#999',
          fontSize: !isAndroid ? 12 : 10
        },
        splitNumber: 1
      }
      option.config.yAxis.push(yAxis)
      if (yKey.length > 1 && !!yKey[1]) {
        const copyYAxis = JSON.parse(JSON.stringify(yAxis))
        this.$set(copyYAxis, 'name', yKey[1])
        option.config.yAxis.push(copyYAxis)
      }
      keys.forEach(item => {
        const itemData = {
          name: item,
          data: data[item].data,
          symbol: 'none',
          lineStyle: {
            type: item === '目标' ? 'dashed' : 'solid',
            width: !isAndroid ? 2 : 0.5
          },
          yAxisIndex: item === '活跃率' ? 1 : 0
        }
        if (type && item !== '目标') {
          this.$set(itemData, 'areaStyle', {})
          this.$set(itemData, 'stack', '总量')
        }
        option.data.push(itemData)
      })
      this[key] = option
    },
    getProject () {
      const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
      this.$service.fetch({
        url: 'api/livingRoom/dashboard',
        params: {
          month: choiceDate.time
        }
      }).then(res => {
        this.tableData = res.livingRoomIndicators
        const timeData = this.timeData
        this.parlorData = res
        this.lineFormatData(res.weekOpenChart, 'weekOpenChart', ['%'])
        this.lineFormatData(res.weekConversionChart, 'weekConversionChart', ['%'])
        this.lineFormatData(res.dayIncome, 'dayIncome', ['万'], 1)
        this.projectLIst = res.projects.map(list => {
          return {
            name: list.name,
            target: list.target,
            currentValue: list.currentValue,
            projectTarget: list.projectTarget,
            data: list.data ? list.data.map(item => {
              const day = parseInt(((this.getTimestamp(item.projectCycleEnd) - this.getTimestamp(item.projectCycleStart)) / 86400) / 1000)
              const upData = timeData.data.up
              const downData = timeData.data.down
              const start = ((this.getTimestamp(item.projectCycleStart) - this.getTimestamp(`${upData.year}/${upData.month}/${upData.day} 00:00:00`)) / 1000) / 86400
              const end = ((this.getTimestamp(item.projectCycleEnd) - this.getTimestamp(`${upData.year}/${upData.month}/${upData.day} 00:00:00`)) / 1000) / 86400
              const startPosition = start ? start > 0 ? parseFloat((start / timeData.totalDay).toFixed(2)) * 100 : 0 : start
              const endPosition = end ? end > 0 ? parseFloat((end / timeData.totalDay).toFixed(2)) * 100 : 100 : end
              return Object.assign(item, {
                day: day,
                width: parseFloat((endPosition - startPosition).toFixed(2)),
                left: startPosition
              })
            }) : null
          }
        })
      })
    },
    getTimestamp (date) {
      return Date.parse(new Date(date))
    },
    getDayDiff (start, end) {
      return parseFloat((((this.getTimestamp(end) - this.getTimestamp(start)) / 1000) / 86400).toFixed(2))
    }
  },
  activated () {
    this.getProject()
  }
}
</script>

<style lang="stylus" scoped>
  @import './stylus/Project-list.styl'
  @import './stylus/Parlor.styl'
</style>
